function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Text from './text';
import useMobile from '../hooks/use-mobile';
import { defaultTextProps, defaultTextPropTypes } from './default-text-props';
export default function H3(props) {
  const mobile = useMobile();
  const size = mobile ? 26 : 39;
  const lineHeight = mobile ? 31.2 : 46.8;
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    fontFamily: "LarsseitBold",
    size: size,
    lineHeight: lineHeight
  }), props.children);
}
H3.defaultProps = defaultTextProps;
H3.propTypes = defaultTextPropTypes;
//# sourceMappingURL=h3.js.map